async function addItemToCart(event, variantId) {
    event.stopPropagation();
    event.preventDefault();

    const button = event.target;
    const iconsWrapper = button.querySelector(".icons-wrapper");

    iconsWrapper.querySelector(".add-icon").classList.add("hidden");
    iconsWrapper.querySelector("div[role='status']").classList.remove("hidden");

    try {
        const object = {
            items: [
                {
                    id: variantId,
                    quantity: 1
                }
            ],
            sections: ["custom-header"]
        }

        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            body: JSON.stringify(object),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const json = await response.json();
        const cartForm = new DOMParser().parseFromString(json.sections['custom-header'], 'text/html');

        document.getElementById("cart-icon-bubble").innerHTML = cartForm.getElementById("cart-icon-bubble").innerHTML;

        iconsWrapper.querySelector(".add-icon").classList.remove("hidden");
        iconsWrapper.querySelector("div[role='status']").classList.add("hidden");

        const quantityOnProductCard = button.querySelector(".in-cart-quantity");
        if (quantityOnProductCard.classList.contains("hidden")) {
            quantityOnProductCard.querySelector("small").innerText = 1;
            
            quantityOnProductCard.classList.remove("hidden");
            quantityOnProductCard.classList.add("flex");
        } else {
            let currentQuantity = quantityOnProductCard.querySelector("small").innerText;
            currentQuantity = parseInt(currentQuantity);
            quantityOnProductCard.querySelector("small").innerText = currentQuantity + 1;
        }

        showNotificationPopup();
        showStickyCartInfo();
    } catch (error) {
        console.error("Error adding item to cart:", error);
    }
}

window.addEventListener("DOMContentLoaded", () => assignMetaBlockAnimations());

function assignMetaBlockAnimations() {
    const textWrappers = document.querySelectorAll(".product-text-slider-container.anim-active");

    textWrappers.forEach(wrapper => {
        const texts = [...wrapper.querySelectorAll(".metadata-block")];
        let activeIndex = 0;

        if (texts.length > 0) {
            function swapTexts() {
                const current = texts[activeIndex];
                const nextIndex = (activeIndex + 1) % texts.length;
                const next = texts[nextIndex];

                current.classList.remove("active");
                current.classList.add("exiting");

                next.classList.add("active");

                setTimeout(() => {
                    current.classList.remove("exiting");
                }, 500);

                activeIndex = nextIndex;
            }

            texts[0].classList.add("active");

            setInterval(swapTexts, 3000);
        }
    });
}

function playVideo(event) {
    event.stopPropagation();
    event.preventDefault();

    const targetDiv = event.currentTarget;
    const video = targetDiv.querySelector("video");
    const playButton = targetDiv.querySelector("svg");

    document.querySelectorAll("video").forEach(v => {
        if (!v.paused && v !== video) {
            v.pause();
            v.removeAttribute("loop");
            const button = v.parentElement.querySelector("svg");
            if (button) button.classList.remove("hidden");
        }
    });

    if (!video) return;

    if (!video.paused) {
        video.pause();
        video.removeAttribute("loop");
        playButton.classList.remove("hidden");
    } else {
        video.play();
        video.setAttribute("loop", true);
        playButton.classList.add("hidden");
    }
}